import { createBrowserRouter, Navigate } from "react-router-dom";

import { LoginPage } from "../features/auth/LoginPage";
import { ForgotPage } from "../features/auth/ForgotPage";
import { ResetPage } from "../features/auth/ResetPage";
import { AcceptInvitePage } from "../features/auth/AcceptInvitePage";
import { ProjectsListPage } from "../features/projects/ProjectsListPage";
import { ProjectOverviewPage } from "../features/projects/ProjectOverviewPage";
import { ProjectConfigPage } from "../features/projects/ProjectConfigPage";
import { PlayersListPage } from "../features/players/PlayersListPage";
import { PlayerDetailPage } from "../features/players/PlayerDetailPage";
import { GuildsListPage } from "../features/guilds/GuildsListPage";
import { GuildDetailPage } from "../features/guilds/GuildDetailPage";
import { LeaderboardsListPage } from "../features/leaderboards/LeaderboardsListPage";
import { LeaderboardCreatePage } from "../features/leaderboards/LeaderboardCreatePage";
import { LeaderboardDetailPage } from "../features/leaderboards/LeaderboardDetailPage";
import { TeamPage } from "../features/team/TeamPage";
import { ApiKeysPage } from "../features/apikeys/ApiKeysPage";
import { UsersPage } from "../features/users/UsersPage";
import { InvitesPage } from "../features/invites/InvitesPage";
import { AccountPage } from "../features/account/AccountPage";
import { ForbiddenPage } from "../features/errors/ForbiddenPage";
import { NotFoundPage } from "../features/errors/NotFoundPage";
import { AppShell } from "./AppShell";
import { AuthGuard } from "./AuthGuard";
import { ConfigOutlineProvider } from "./ConfigOutline";

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  { path: "/forgot", element: <ForgotPage /> },
  { path: "/reset", element: <ResetPage /> },
  { path: "/accept", element: <AcceptInvitePage /> },
  {
    path: "/",
    element: (
      <AuthGuard>
        <ConfigOutlineProvider>
          <AppShell />
        </ConfigOutlineProvider>
      </AuthGuard>
    ),
    children: [
      { index: true, element: <Navigate to="/projects" replace /> },
      { path: "projects", element: <ProjectsListPage /> },
      // /projects/:id → redirect to overview tab.
      { path: "projects/:id", element: <Navigate to="overview" replace /> },
      { path: "projects/:id/overview", element: <ProjectOverviewPage /> },
      { path: "projects/:id/config", element: <ProjectConfigPage /> },
      { path: "projects/:id/players", element: <PlayersListPage /> },
      { path: "projects/:id/players/:playerId", element: <PlayerDetailPage /> },
      { path: "projects/:id/guilds", element: <GuildsListPage /> },
      { path: "projects/:id/guilds/:guildId", element: <GuildDetailPage /> },
      { path: "projects/:id/leaderboards", element: <LeaderboardsListPage /> },
      { path: "projects/:id/leaderboards/new", element: <LeaderboardCreatePage /> },
      { path: "projects/:id/leaderboards/:lbId", element: <LeaderboardDetailPage /> },
      { path: "projects/:id/team", element: <TeamPage /> },
      { path: "projects/:id/api-keys", element: <ApiKeysPage /> },
      { path: "users", element: <UsersPage /> },
      { path: "invites", element: <InvitesPage /> },
      // /me is the canonical account route (mockup); /account kept as alias.
      { path: "me", element: <AccountPage /> },
      { path: "account", element: <AccountPage /> },
      { path: "403", element: <ForbiddenPage /> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);
